import axios from 'axios'

class DocumentoAnexosApiClient {
	constructor(urlBuilder) {
		this.urlBuilder = urlBuilder
	}

	async inserirAnexo(anexo) {
		return await axios.post(this.urlBuilder.anexo.getUrlInserir(), anexo)
	}
}

export default DocumentoAnexosApiClient
